module.exports = __webpack_public_path__ + "static/media/icn_sort_alphabetic.6ff85b83.svg";